export default defineNuxtPlugin(() => {
  useHead({
    script: [
      {
        children: `
          window.NREUM = {
        init: {
          distributed_tracing: { enabled: true },
          privacy: { cookies_enabled: true },
          ajax: { deny_list: ["bam.eu01.nr-data.net"] }
        },
        loader_config: {
          accountID: "4401131",
          trustKey: "4401131",
          agentID: "538714822",
          licenseKey: "NRJS-263167379c2dfb273be",
          applicationID: "538714822"
        },
        info: {
          beacon: "bam.eu01.nr-data.net",
          errorBeacon: "bam.eu01.nr-data.net",
          licenseKey: "NRJS-263167379c2dfb273be",
          applicationID: "538714822",
          sa: 1
        }
      };
        `,
        type: "text/javascript"
      },
      {
        src: "https://js-agent.newrelic.com/nr-loader-spa-1.289.0.min.js",
        async: true
      }
    ]
  });
});
